import { mapState, mapGetters } from 'vuex';
import contactService from '@mixins/officialTopup/contactService';
import login from '@mixins/officialTopup/login';
import coupon from '@mixins/officialTopup/coupon';
import pay from '@mixins/officialTopup/pay';
import { clickButton, locationType } from '@plugins/biPoint/_configWebstoreV3';
import { sdkOpenLink } from '@utiles/officialStore/sdkCtrl';
import { OPEN_GLOBAL_TIPS } from '@store/officialTopup';
import { getGlobalGetGotoLink } from '@utiles/globalGetLink';
export default {
  mixins: [contactService, login, coupon, pay],
  computed: {
    ...mapState({
      loading: state => state.loading,
      gameId: state => state.gameId,
      roleName: state => state.roleName,
      pcServerId: state => state.pcServerId,
      uid: state => state.login.uid,
      loginAccount: state => state.login.loginAccount,
      rightsLink: state => state.page.rightsLink
    }),
    ...mapGetters(['isJpPlatform'])
  },
  methods: {
    accountHandle(type) {
      switch (type) {
        case 'coupon':
          this.refreshGameCoupon();
          this.hideAccountSelecter();
          break;
        case 'vip':
          if (!this.rightsLink) {
            //  todo：后面是否换成v3的多语言
            this.$store.commit(OPEN_GLOBAL_TIPS, this.letter.smartOrderComing);
            return;
          }
          sdkOpenLink({
            link: getGlobalGetGotoLink({ link: this.rightsLink })
          });
          clickButton({
            btnName: 'go_rightcenter',
            locationKey: this.$route.meta.pageName
          });
          break;
        case 'activity':
          if (this.$route.name === 'home') {
            this.handleReSelectProduct();
            document
              .getElementById('limitTimeActivity')
              ?.scrollIntoView({ behavior: 'smooth' });
            this.hideAccountSelecter();
          } else {
            this.$router.push({ name: 'home' });
          }
          break;
        case 'order':
          clickButton({
            btnName: 'order_history',
            locationKey: this.$route.meta.pageName
          });
          break;
        case 'service':
          this.openService();
          clickButton({
            btnName: 'customer_service',
            locationKey: this.$route.meta.pageName
          });
          break;
        case 'more':
          if (this.$route.name === 'mine') {
            this.hideAccountSelecter();
          } else {
            this.hideAccountSelecter();
            this.$router.push({ name: 'mine' });
            clickButton({
              btnName: 'user_center',
              locationKey: locationType.accountInfo
            });
            setTimeout(() => {
              document
                .getElementById('minePage')
                ?.scrollIntoView({ behavior: 'smooth' });
            }, 200);
            break;
          }
        default:
          break;
      }
    },
    handleGoLogOut() {
      clickButton({
        btnName: 'logout',
        locationKey: this.$route.meta.pageName
      });
      this.goLogOut();
    },
    rememberStatusHandle() {
      this.isRememberStatus = !this.isRememberStatus;
    },
    openService() {
      clickButton({
        btnName: 'customer_service',
        locationKey: this.$route.meta.pageName
      });
      this.isJpPlatform
        ? this.jpService()
        : this.openGlobalService({
            gameId: this.gameId,
            roleId: this.roleId,
            roleName: this.roleName,
            serverId: this.pcServerId,
            isUidLogin: this.isUidLogin,
            uid: this.uid,
            loginAccount: this.loginAccount
          });
    },
    hideAccountSelecter() {
      this.$emit('hideAccountSelecter');
    }
  }
};
